// Round 95p·2 (Feb 2026) — Live checklist showing which password
// rules currently pass. Shows only after user starts typing to avoid
// nagging on empty state.
import { Check, X } from 'lucide-react';
import { validatePassword } from '@/lib/passwordRules';

export default function PasswordStrengthMeter({ password }) {
  if (!password) return null;
  const { rules } = validatePassword(password);
  return (
    <ul className="space-y-1 mt-1" data-testid="password-strength-meter">
      {rules.map(r => (
        <li
          key={r.key}
          className={`flex items-center gap-1.5 text-[11px] ${
            r.ok ? 'text-emerald-600 dark:text-emerald-400' : 'text-muted-foreground'
          }`}
          data-testid={`password-rule-${r.key}`}
          data-ok={r.ok ? 'true' : 'false'}
        >
          {r.ok ? <Check className="w-3 h-3" /> : <X className="w-3 h-3" />}
          <span>{r.label}</span>
        </li>
      ))}
    </ul>
  );
}
